import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Legal() {
  useEffect(() => {
    document.title = 'Legal Notice — SeaCloud Software';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-inner">
        <Link to="/" className="legal-back">← Back to home</Link>

        <h1 className="legal-title">Legal Notice</h1>
        <p className="legal-subtitle">Impresum / Company Information</p>

        <div className="legal-card">
          <div className="legal-row">
            <span className="legal-label">Company</span>
            <span className="legal-value">SeaCloud Software d.o.o. za računalne usluge</span>
          </div>
          <div className="legal-row">
            <span className="legal-label">Address</span>
            <span className="legal-value">Ulica Milana Pavelića 1B, 10000 Zagreb, Croatia</span>
          </div>
          <div className="legal-row">
            <span className="legal-label">Court register</span>
            <span className="legal-value">Trgovački sud u Zagrebu, MBS 081247210</span>
          </div>
          <div className="legal-row">
            <span className="legal-label">OIB</span>
            <span className="legal-value">01433662496</span>
          </div>
          <div className="legal-row">
            <span className="legal-label">Share capital</span>
            <span className="legal-value">20.000,00 HRK — fully paid in cash</span>
          </div>
          <div className="legal-row">
            <span className="legal-label">Bank</span>
            <span className="legal-value">Zagrebačka Banka d.d.</span>
          </div>
          <div className="legal-row">
            <span className="legal-label">IBAN</span>
            <span className="legal-value legal-mono">HR7023600001102793662</span>
          </div>
          <div className="legal-row">
            <span className="legal-label">SWIFT / BIC</span>
            <span className="legal-value legal-mono">ZABAHR2X</span>
          </div>
          <div className="legal-row">
            <span className="legal-label">Director</span>
            <span className="legal-value">Tomislav Horvatiček</span>
          </div>
          <div className="legal-row">
            <span className="legal-label">Email</span>
            <span className="legal-value">
              <a href="mailto:hello@seacloud-software.hr" className="legal-link">hello@seacloud-software.hr</a>
            </span>
          </div>
        </div>

        <p className="legal-footer-note">
          <Link to="/privacy" className="legal-link" style={{ marginRight: '16px' }}>Privacy Policy</Link>
          © {new Date().getFullYear()} SeaCloud Software d.o.o. All rights reserved.
        </p>
      </div>
    </div>
  );
}
